import { useState } from 'react'
import clsx from 'clsx'

import { groupsShort } from '../../utils/dummyData/groups'

const HomeHeaderSimple: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState(groupsShort[0])
  return (
    <section className="border-theme sticky top-0 z-[50] flex h-[50px] w-full overflow-hidden border-r border-b border-l backdrop-blur-xl">
      <div className="border-theme flex h-[50px] grow border-b bg-transparent">
        <div
          className="hover-main relative flex h-full flex-1 items-center justify-center px-[20px]"
          onClick={() => setSelectedTab(groupsShort[0])}
        >
          <div className="relative flex h-full items-center justify-center px-[10px] font-semibold tracking-tight">
            <p
              className={clsx('flex w-full items-center text-nowrap', {
                'text-main': selectedTab.id === groupsShort[0].id,
                'text-sub': selectedTab.id !== groupsShort[0].id,
              })}
            >
              {groupsShort[0].title}
            </p>
            {selectedTab.id === groupsShort[0].id && (
              <div className="bgd-blue absolute bottom-0 h-[3px] w-full"></div>
            )}
          </div>
        </div>
        <div className="text-sub hover-disabled relative flex h-full flex-1 cursor-not-allowed items-center justify-center px-[20px]">
          <div className="relative flex h-full items-center justify-center px-[10px] font-semibold tracking-tight">
            <p className="flex w-full items-center text-nowrap">
              {groupsShort[1].title}
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HomeHeaderSimple
